import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {onChangeScreenWidth, onPaginationChange} from "./redux/actions/layout/interaction/action";
import MainLayout from "./layout";
import CanRouter from "./components/can/Router";
import LoginPageInstanceNew from "./common/login/new/LoginPageInstanceNew";
import useNetwork from "./custom/network";
import {BsWifi, BsWifiOff} from "react-icons/bs";
import {RiCloseCircleLine} from "react-icons/ri";
import {notification} from "antd";
import NotFound from "./custom/notFound/notFound";
import ForgetPassword from "./common/login/new/ForgetPassword";
import useWebSocket from "react-use-websocket";

function App() {
    const dispatch = useDispatch()
    const {page} = useSelector(state => state.layoutInteractionReducer)
    const online = useNetwork();

    useEffect(() => {
        if (online !== undefined) {
            notification.open({
                key: "updateNetwork",
                icon: online ? <BsWifi/> : <BsWifiOff/>,
                message: online ? "Đã khôi phục kết nối Internet." : "Bạn đang offline.",
                placement: "bottomLeft",
                duration: online ? 5 : 0,
                closeIcon: <RiCloseCircleLine fontSize={22}/>,
                style: {
                    borderRadius: 8,
                    width: 'auto'
                }
            })
        }

    }, [online]);

    const width = window.innerWidth

    useEffect(() => {
        if (width <= 1300) dispatch(onChangeScreenWidth(true));
        else dispatch(onChangeScreenWidth(false));
    }, [width, dispatch])

    useEffect(() => {
        if (window.screen.width <= 1300) dispatch(onPaginationChange(page, 4))

        document.title = "Hệ thống theo dõi trạm cân từ xa"
    }, [dispatch, page])

    // WebSocket URL: tự động detect protocol và host từ window.location
    const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const wsHost = window.location.host;
    const wsUrl = `${wsProtocol}//${wsHost}/ws/weighing`;
    
    const { sendMessage, lastMessage, readyState } =
        useWebSocket(wsUrl);

    useEffect(() => {
        if (lastMessage !== null) {
            console.log("trung " , lastMessage)
        }
    }, [lastMessage]);

    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPageInstanceNew/>}/>
                    <Route path="/forget-password" element={<ForgetPassword/>}/>

                    <Route path="/*" element={<MainLayout/>}>
                        <Route path={"can/*"} element={<CanRouter/>}/>
                    </Route>
                    <Route path="/:somestring" element={<NotFound/>}/>
                </Routes>
            </BrowserRouter>
        </>

    );

}


export default App;
